import React from 'react';
import RemittanceQuery from './components/RemittanceQuery';
import './App.css';

function App() {
  return (
    <div className="App">
      <RemittanceQuery />
    </div>
  );
}

export default App;
